import { ITag } from '@fluentui/react';
import React from 'react';

import Collapsible from './Collapsible';

import { IGenericFilterTag } from '../../../utils/types/IGenericFilterTag';
import GenericChecklist from './GenericChecklist';
import { GET_COUNTRIES_BY_SEARCH_INPUT } from '../../../utils/statApi/CountryApi';

export interface IChecklistImplementationProps {
  onSelectedItems?: (selectedItems: IGenericFilterTag) => void;
  initialValues?: IGenericFilterTag;
  disabledValues?: IGenericFilterTag;
  label: string;
  dataKey: string;
}

const CountryCollapsibleChecklist = (props: IChecklistImplementationProps): JSX.Element => {
  const { onSelectedItems, initialValues, label, dataKey, disabledValues } = props;

  const onCheckChanged = (items: ITag[]): void => {
    onSelectedItems({
      dataKey,
      title: label,
      values: items,
    });
  };

  const mapToTag = (item: { id: string; shortName: string }): ITag => {
    return {
      key: item.id,
      name: item.shortName.toString(),
    };
  };

  const mapData = (data: { countries: { id: string; shortName: string }[] }): ITag[] => {
    return data?.countries?.map((countries) => {
      return mapToTag(countries);
    });
  };

  return (
    <Collapsible text={label}>
      <GenericChecklist
        mapData={mapData}
        query={GET_COUNTRIES_BY_SEARCH_INPUT}
        onCheckChanged={onCheckChanged}
        selections={initialValues?.values ?? []}
        disabledItems={disabledValues?.values ?? []}
      />
    </Collapsible>
  );
};

export default CountryCollapsibleChecklist;
